import { useNavigate } from 'react-router-dom';
import { PublicationCreationChoiceModal } from './PublicationCreationChoiceModal';
import { PublicationCreationMode } from '../types';

export type PublicationPresetSchedule = Readonly<{
    date: string;
    hour: string;
    minute: string;
}>;

type AddPublicationLocationState = Readonly<{
    creationMode: PublicationCreationMode;
    presetSchedule?: PublicationPresetSchedule;
}>;

type PublicationChoiceModalProps = Readonly<{
    isOpen: boolean;
    onRequestClose: () => void;
    presetSchedule?: PublicationPresetSchedule;
}>;

function createAddPublicationLocationState(
    creationMode: PublicationCreationMode,
    presetSchedule: PublicationPresetSchedule | undefined,
): AddPublicationLocationState {
    if (presetSchedule === undefined) {
        return { creationMode };
    }
    return { creationMode, presetSchedule };
}

export function PublicationChoiceModal({
    isOpen,
    onRequestClose,
    presetSchedule,
}: PublicationChoiceModalProps) {
    const navigate = useNavigate();

    const handleValidate = (creationMode: PublicationCreationMode) => {
        onRequestClose();
        navigate('/add_publication', {
            state: createAddPublicationLocationState(creationMode, presetSchedule),
        });
    };

    return (
        <PublicationCreationChoiceModal
            isOpen={isOpen}
            onClose={onRequestClose}
            onValidate={handleValidate}
        />
    );
}
